import { IEquipmentTypes } from 'types/graphqlTypes'
import {
  IDoorTypes,
  IFloorTypes,
  IReeferDownloadableReportTypes,
  IReeferFlowTypes,
  IReeferTempControlTypes,
  IRoofTypes,
  ITrackTypes,
  IWallTypes,
} from 'apps/marketplace/types/equipment'
import { DISPLAY } from 'constants/display'

const EMPTY_OPTION = {
  label: DISPLAY.empty,
  value: '',
}

export const EQUIPMENT_OPTIONS = [
  {
    label: 'Dry Van',
    value: IEquipmentTypes.dry_van,
  },
  {
    label: 'Reefer',
    value: IEquipmentTypes.reefer,
  },
  {
    label: 'Open Deck',
    value: IEquipmentTypes.open_deck,
  },
  {
    label: 'Specialized',
    value: IEquipmentTypes.specialized,
  },
]

export const EQUIPMENT_TYPE_OPTIONS = {
  dry_van: [
    { label: "53' Van", value: IEquipmentTypes._53_van },
    { label: "48' Van", value: IEquipmentTypes._48_van },
    { label: "40' Van", value: IEquipmentTypes._40_van },
    { label: "20' Van", value: IEquipmentTypes._20_van },
    { label: 'Vented Van', value: IEquipmentTypes.vented_van },
    { label: 'Plate Trailer', value: IEquipmentTypes.plate_trailer },
  ],
  reefer: [
    { label: "53' Reefer", value: IEquipmentTypes._53_reefer },
    { label: "48' Reefer", value: IEquipmentTypes._48_reefer },
    { label: 'Space Saver Reefer', value: IEquipmentTypes.space_saver_reefer },
    { label: 'Ice Cream Trailer', value: IEquipmentTypes.ice_cream_trailer },
  ],
  open_deck: [
    { label: "53' Flatbed", value: IEquipmentTypes._53_flatbed },
    { label: "48' Flatbed", value: IEquipmentTypes._48_flatbed },
    { label: 'Double Drop', value: IEquipmentTypes.double_drop },
    { label: 'Stepdeck', value: IEquipmentTypes.stepdeck },
  ],
}

export const TRACKS_OPTIONS = [
  EMPTY_OPTION,
  { label: 'E-Tracks', value: ITrackTypes.eTracks },
  { label: 'Vertical Tracks', value: ITrackTypes.verticalTracks },
]

export const YEARS_OPTIONS = Array.from({ length: 26 }, (_, index) => {
  const currentYear = new Date().getFullYear()
  const optionYear = `${currentYear - index}`

  return {
    label: optionYear,
    value: optionYear,
  }
})

export const ROOF_OPTIONS = [
  EMPTY_OPTION,
  { label: 'Non-Translucent Roof', value: IRoofTypes.nonTranslucentRoof },
  { label: 'Metal Roof', value: IRoofTypes.metalRoof },
]

export const DOOR_OPTIONS = [
  EMPTY_OPTION,
  { label: 'Swing Doors', value: IDoorTypes.swingDoors },
  { label: 'Roll Doors', value: IDoorTypes.rollDoors },
]

export const WALL_OPTIONS = [
  EMPTY_OPTION,
  { label: 'Wood Walls', value: IWallTypes.woodWalls },
  { label: 'Fiberglass Walls', value: IWallTypes.fiberglassWalls },
]

export const FLOOR_OPTIONS = [
  EMPTY_OPTION,
  { label: 'Metal Floor', value: IFloorTypes.metalFloor },
  { label: 'Wood Floor', value: IFloorTypes.woodFloor },
  { label: 'D-Ring Floor', value: IFloorTypes.dRingFloor },
]

export const REEFER_TEMP_CONTROL_OPTIONS = [
  {
    label: 'Fixed',
    id: IReeferTempControlTypes.fixed,
  },
  {
    label: 'Range',
    id: IReeferTempControlTypes.range,
  },
]

export const REEFER_FLOW_OPTIONS = [
  {
    label: `Cont'`,
    id: IReeferFlowTypes.continuous,
  },
  {
    label: 'Start/Stop',
    id: IReeferFlowTypes.startStop,
  },
]

export const REEFER_REPORT_OPTIONS = [
  {
    label: 'Yes',
    id: IReeferDownloadableReportTypes.yes,
  },
  {
    label: 'No',
    id: IReeferDownloadableReportTypes.no,
  },
]
